import { render, staticRenderFns } from "./jobReqDetail.vue?vue&type=template&id=6c5d3afd&scoped=true"
import script from "./jobReqDetail.vue?vue&type=script&lang=js"
export * from "./jobReqDetail.vue?vue&type=script&lang=js"
import style0 from "./jobReqDetail.vue?vue&type=style&index=0&id=6c5d3afd&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5d3afd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c5d3afd')) {
      api.createRecord('6c5d3afd', component.options)
    } else {
      api.reload('6c5d3afd', component.options)
    }
    module.hot.accept("./jobReqDetail.vue?vue&type=template&id=6c5d3afd&scoped=true", function () {
      api.rerender('6c5d3afd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/dialog/jobReqDetail.vue"
export default component.exports